;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.core').config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.promotions', {
      url: '/promotions?query&status',
      params: {
        query: { dynamic: true },
        status: { dynamic: true },
      },
      templateUrl: 'promotions.html',
      controller: 'Promotions',
      controllerAs: '$ctrl',
    })
  }
})()
